module.exports = __webpack_public_path__ + "img/list_D10A.d974adae.png";